import axios from "axios";

export async function refreshToken() {
	const response = await axios.post(`${process.env.REACT_APP_BACKEND_URL}/token/refresh`, {
		refresh_token: localStorage.getItem(process.env.REACT_APP_REFRESH_TOKEN_NAME),
	});
	localStorage.setItem(process.env.REACT_APP_TOKEN_NAME, response.data.token);
	localStorage.setItem(process.env.REACT_APP_REFRESH_TOKEN_NAME, response.data.refresh_token);
	return response.data;
}
